module.exports = __webpack_public_path__ + "static/media/achievement-book-worm.df0aec5d.svg";